import { startOfDay, differenceInDays } from 'date-fns';

const normalizeDay = startOfDay;
function getDayCountInRange(startDate, endDate, excludeDates = []) {
  const startOfStartDate = normalizeDay(startDate);
  const startOfEndDate = normalizeDay(endDate);
  if (startOfEndDate < startOfStartDate) {
    return 0;
  }
  const dayCount = differenceInDays(startOfEndDate, startOfStartDate) + 1;
  const excludedDayCount = excludeDates.filter((excludeDate) => {
    const startOfExcludeDate = normalizeDay(excludeDate);
    const isAfterStartDate = startOfExcludeDate >= startOfStartDate;
    const isBeforeEndDate = startOfExcludeDate <= startOfEndDate;
    return isAfterStartDate && isBeforeEndDate;
  });
  return dayCount - excludedDayCount.length;
}

export { getDayCountInRange };
//# sourceMappingURL=getDayCountInRange.mjs.map
